/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据榜单Id获取榜单详情
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  billboardId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.BillboardInfoDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/bill-board/${billboardId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
